/* src/app/app.component.css */
.main {
  width: 100%;
  height: 100vh;
  overflow: hidden;
  font-size: smaller;
  position: fixed;
}
.global-progress {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  z-index: 10000;
  overflow: hidden;
  pointer-events: none;
  background: color-mix(in srgb, var(--tem-accent) 15%, transparent);
  animation: global-progress-fadein 0.001s linear 0.15s both;
}
.global-progress::after {
  content: "";
  position: absolute;
  height: 100%;
  width: 40%;
  border-radius: 3px;
  background: var(--tem-accent);
  animation: global-progress-slide 1.2s ease-in-out infinite;
}
@keyframes global-progress-slide {
  0% {
    left: -40%;
  }
  100% {
    left: 100%;
  }
}
@keyframes global-progress-fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@media print {
  html,
  body {
    display: none;
  }
}
/*# sourceMappingURL=app.component.css.map */
